const FILENAME_PREFIX = 'pay-per-use-leaderboard';

export const buildLeaderboardExportFilename = (month: string) => `${FILENAME_PREFIX}-${month}`;
